import { dsClass } from '../../common/constants/dsClasses';

export type SubscriptionCardOfferSpec = {
  name: string;
  value: string;
};

export const OfferSpecifications = ({ specifications }: { specifications?: SubscriptionCardOfferSpec[] }) => {
  return (
    <div className={dsClass.MARGIN_TOP_2}>
      {specifications?.map((specification, i) => (
        <div
          key={`offer-inclusion-row-${i}`}
          className={`of-subscription-card--specification ${dsClass.DISPLAY_FLEX} ${dsClass.JUSTIFY_CONTENT_SPACE_BETWEEN} ${dsClass.MARGIN_TOP_1}`}
          aria-disabled="true"
        >
          <div className={`${dsClass.TEXT_XS} of-subscription-card--specification--start`}>{specification.name}</div>
          <div className="of-subscription-card--specification--word-separator"></div>
          <div className={`${dsClass.TEXT_XS} of-subscription-card--specification--end`}>{specification.value}</div>
        </div>
      ))}
    </div>
  );
};
